import { defineStore } from 'pinia'
import { ref, type Ref } from 'vue'
import { PopupRouter } from '@/popup/PopupRouter'
import type { RegisterRoute } from '@/popup/RouterTypes'
import type { Maybe } from '@/types'

function getRandomInt(max: number) {
  return Math.floor(Math.random() * Math.floor(max))
}

const usePopupStore = defineStore('popup', () => {
  const popupRouterList: Ref<Record<number, Maybe<PopupRouter>>> = ref({})

  const createPopupRouter = (
    routes: RegisterRoute[],
  ): [number, PopupRouter] => {
    const router = new PopupRouter(routes)
    const index = getRandomInt(Number.MAX_SAFE_INTEGER)
    popupRouterList.value[index] = router
    return [index, router]
  }

  const getPopupRouter = (index: number) => {
    return popupRouterList.value[index]
  }

  const reset = () => {
    popupRouterList.value = {}
  }
  return {
    popupRouterList,
    createPopupRouter,
    getPopupRouter,
    reset,
  }
})

export { usePopupStore }
